import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba9b007"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "scrollable-content" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "company-info" }
const _hoisted_5 = { class: "company-logo" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "company-logo-placeholder"
}
const _hoisted_8 = { class: "company-details" }
const _hoisted_9 = { class: "company-subtitle" }
const _hoisted_10 = { class: "status-section" }
const _hoisted_11 = { class: "status-content" }
const _hoisted_12 = { class: "status-title" }
const _hoisted_13 = { class: "status-subtitle" }
const _hoisted_14 = { class: "details-section" }
const _hoisted_15 = { class: "details-card" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = { class: "detail-item" }
const _hoisted_18 = { class: "detail-item" }
const _hoisted_19 = { class: "detail-item" }
const _hoisted_20 = { class: "detail-item" }
const _hoisted_21 = { class: "action-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "text-selectable modal-content" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.invoice.deal?.contractingCompany?.mediaLogo?.readPublicLink)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.invoice.deal?.contractingCompany?.mediaLogo?.readPublicLink,
                      alt: _ctx.invoice.deal?.brand?.name
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'building'] })
                    ]))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", {
                  class: "company-name",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToDealDetails && _ctx.navigateToDealDetails(...args)))
                }, _toDisplayString(_ctx.invoice.deal?.brand?.name), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t("common.invoice")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["status-card", 'status-card--' + (_ctx.invoice?.paymentStatus && _ctx.invoice?.status != 2 ? _ctx.paymentStatus.color : _ctx.status.color)])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.invoice?.paymentStatus && _ctx.invoice?.status != 2 ? _ctx.paymentStatus.text : _ctx.status.text), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t("common.invoice-status")), 1)
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("common.invoice-number")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.invoice.documentNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("common.invoice-date")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.dateStr), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("common.subtotal")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.amount), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("common.vat")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.vat), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("common.total")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.total), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            class: "primary-action",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'download'],
                class: "button-icon"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.download-pdf")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}